<template>
  <div class="custom-form">
    <!-- ref 跟 model 的變數不可以一樣 -->
    <el-form
      ref="customFormRef"
      class="form-container"
      :class="[{ 'main-container': type === 'popup' }, type]"
      :label-position="showLabel ? 'left' : ''"
      :label-width="renderLabelWidth(type)"
      :model="newData"
      @submit.prevent=""
    >
      <el-form-item
        v-for="col in cols"
        :id="col.id"
        :key="type + col.id"
        :label="showLabel ? col.label : ''"
        :prop="col.id"
        :rules="col.rules ? col.rules : initRule"
      >
        <!-- type: title -->
        <el-row
          v-if="col.type === 'header'"
          class="header"
        >
          <el-col :span="24">
            <icon-button
              class="close"
              color-type="black"
              icon-type="close"
              @click="exitFn"
            />
            <div class="title">
              {{ col.label }}
            </div>
          </el-col>
        </el-row>
        <!-- type: password -->
        <el-input
          v-else-if="col.type === 'password'"
          v-model="newData[col.id]"
          :disabled="col.disabled"
          :placeholder="col.placeholder"
          show-password
        />
        <!-- type: form-select -->
        <el-select
          v-else-if="col.type === 'form-select'"
          v-model="newData[col.id]"
          :disabled="col.disabled"
          :filterable="col.filterable"
          :fit-input-width="true"
          :multiple="col.multiple"
          :multiple-limit="col.limit"
          no-data-text="無符合選項"
          :placeholder="col.placeholder"
          :popper-class="`custom-poper-select ${type}`"
        >
          <el-option
            v-for="option in col.options"
            :key="option.id"
            :label="option.label"
            :value="option.value"
          >
            {{ option.label }}
          </el-option>
        </el-select>
        <!-- type: thumbnail-select -->
        <el-row
          v-else-if="col.type === 'thumbnail-select'"
          class="main-header"
          :class="[{ 'event error': Object.values(newData[col.id]).length >= 1 }]"
          justify="space-between"
        >
          <el-col :span="12">
            <div class="label">
              {{ col.label }}
            </div>
          </el-col>
          <el-col :span="12">
            <el-select
              v-model="newData[col.id]"
              class="custom-select"
              :fit-input-width="true"
              :placeholder="col.placeholder"
              popper-class="custom-poper-select"
              size="mini"
              value-key="id"
            >
              <div class="select-header">
                {{ col.placeholder }}
              </div>
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="user.name"
                :value="user"
              >
                <designer-thumbnail
                  type="select-option"
                  :user="user"
                />
              </el-option>
            </el-select>
          </el-col>
          <el-col
            v-if="Object.values(newData[col.id]).length >= 1"
            class="event-error"
            :span="24"
          >
            <div class="event-status-text">
              區間已有其他事件
            </div>
          </el-col>
        </el-row>
        <!-- type: date-picker -->
        <el-row
          v-else-if="col.type === 'date-picker'"
          class="main-header"
        >
          <el-col :span="12">
            <div class="label">
              {{ col.label }}
            </div>
          </el-col>
          <el-col :span="12">
            <el-popover
              placement="bottom-end"
              popper-class="poper-container"
              trigger="click"
              :width="300"
            >
              <template #reference>
                <div class="flex-end">
                  {{ renderSelectedDate('date', newData[col.id]) }}
                </div>
              </template>
              <custom-date-picker
                ref="datePickerRef"
                v-model:selected-date="newData[col.id]"
                :is-more-date-picker="isMoreDatePicker"
                mode="day"
              />
            </el-popover>
          </el-col>
        </el-row>
        <!-- type: time-picker -->
        <el-row
          v-else-if="col.type === 'time-picker'"
          class="main-header two-columns"
        >
          <!-- Display two columns -->
          <template v-if="col.subCols.length >= 1">
            <template
              v-for="subCol in col.subCols"
              :key="subCol.id"
            >
              <el-col
                :span="subCol.span"
              >
                <div class="label">
                  {{ subCol.label }}
                </div>
                <div class="flex-end">
                  <el-time-picker
                    :ref="`${subCol.id}Ref`"
                    v-model="newData[subCol.id]"
                    class="custom-time-picker"
                    :clearable="false"
                    format="HH:mm"
                    popper-class="custom-poper-timer-picker"
                    prefix-icon="null"
                    size="mini"
                  />
                  <div @click.prevent="onClickTimePicker(subCol.id)">
                    {{ renderSelectedDate('time', newData[subCol.id]) }}
                  </div>
                </div>
              </el-col>
            </template>
          </template>
          <!-- Display one column -->
          <template v-else>
            <el-col :span="col.span">
              <div class="label">
                {{ col.label }}
              </div>
            </el-col>
            <el-col
              class="flex-end"
              :span="col.span"
            >
              <el-time-picker
                :ref="`${col.id}Ref`"
                v-model="newData[col.id]"
                class="custom-time-picker"
                :clearable="false"
                format="HH:mm"
                prefix-icon="null"
                size="mini"
              />
              <div @click.prevent="onClickTimePicker(col.id)">
                {{ renderSelectedDate('time', newData[col.id]) }}
              </div>
            </el-col>
          </template>
        </el-row>
        <!-- type: textarea -->
        <el-row
          v-else-if="col.type === 'textarea'"
          class="main-header custom-textarea"
        >
          <el-col :span="24">
            <el-input
              v-model="newData[col.id]"
              :autosize="col.autosize"
              :placeholder="col.placeholder"
              :rows="col.rows"
              type="textarea"
            />
          </el-col>
        </el-row>
        <!-- type: number -->
        <el-input
          v-else-if="col.type === 'number'"
          v-model.number="newData[col.id]"
          :disabled="col.disabled"
          :placeholder="col.placeholder"
          type="age"
        />
        <!-- type: input-mask -->
        <input
          v-else-if="col.type === 'input-mask'"
          v-model="newData[col.id]"
          v-mask="col.mask"
          class="input-mask-item"
          :disabled="col.disabled"
          :placeholder="col.placeholder"
          :type="col.inputType ? col.inputType : 'text'"
          @input="onInputMaskValue($event, col.id)"
        >
        <!-- type: input-dropdown -->
        <el-input
          v-else-if="col.type === 'input-dropdown'"
          v-model="newData[col.id]"
          class="input-dropdown"
          :disabled="col.disabled"
          :placeholder="col.placeholder"
        >
          <template #append>
            <el-select
              v-model="newData[col.dropdownKey]"
              :placeholder="col.dropdownPlaceholder"
              @visible-change="col.visibleChangeFn"
            >
              <el-option
                v-for="option in col.dropdownOptions"
                :key="`dropdown${option.value}`"
                :disabled="option.disabled"
                :label="option.label"
                :value="option.value"
              />
            </el-select>
          </template>
        </el-input>
        <!-- type: phone-number -->
        <el-input
          v-else-if="col.type === 'phone'"
          v-model.trim="newData[col.id].number"
          autocomplete="tel"
          :disabled="col.disabled"
          inputmode="numeric"
          pattern="[0-9]*"
          :placeholder="col.placeholder"
          @keyup.enter="$emit('submit')"
        />
        <!-- type: sms -->
        <el-input
          v-else-if="col.type === 'sms'"
          v-model.trim="newData[col.id]"
          autocomplete="on"
          :disabled="col.disabled"
          inputmode="numeric"
          maxlength="6"
          name="sms-code"
          pattern="[0-9]"
          :placeholder="col.placeholder"
        />
        <!-- default type: text -->
        <el-input
          v-else
          v-model.trim="newData[col.id]"
          :disabled="col.disabled"
          :placeholder="col.placeholder"
          @keyup.enter="$emit('submit')"
        />

        <!-- Label Slot -->
        <template #label>
          <template v-if="col.type === 'phone'">
            <el-select
              v-model="newData[col.id].code"
              class="country-codes-select"
            >
              <el-option
                v-for="item in countryCallingCodeOptions"
                :key="item.value"
                :label="item.prefix"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </template>
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const initRule = [
  {
    validator: (_rule, _value, callback) => {
      callback()
    },
    trigger: 'blur',
  },
]
</script>

<script setup>
import { ElMessageBox } from 'element-plus'
import { cloneDeep, isArray, isEqual } from 'lodash-es'
import { mask } from 'vue-the-mask'

import { useCountryCallingCodeOptions } from '@/composables/useCountryCallingCodeOptions'
import { renderJSDateFormat } from '@/utils/timeFormat.js'

defineOptions({
  directives: {
    mask,
  },
})

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: 'form',
  },
  cols: {
    type: Array,
    required: true,
    default: () => [],
  },
  users: {
    type: Array,
    required: false,
    default: () => [],
  },
  data: {
    type: Object,
    required: true,
    default: () => {},
  },
  // 是否顯示欄位名稱
  showLabel: {
    type: Boolean,
    required: false,
    default: true,
  },
  // 是否資料相同才可送值
  needDiff: {
    type: Boolean,
    required: false,
    default: true,
  },
  // 是否略過資料變更確認視窗
  leaveConfirm: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits(['submit', 'exit'])

const newData = reactive(props.data)
const oldData = cloneDeep(props.data)
const customFormRef = ref(null)
const datePickerRef = ref(null)
const startTimePickerRef = ref(null)
const endTimePickerRef = ref(null)
const isMoreDatePicker = ref(true)

const countryCallingCodeOptions = useCountryCallingCodeOptions()

const checkArr = value => {
  return isArray(value)
}
const renderSelectedDate = (type = '', value) => {
  switch (type) {
    case 'time':
      return renderJSDateFormat({ date: value, format: 'a h:mm 時' })
    default:
      return renderJSDateFormat({ date: value, format: 'L 月 d 日' })
  }
}
const onClickTimePicker = value => {
  value === 'startTimePicker'
    ? startTimePickerRef.value.focus()
    : endTimePickerRef.value.focus()
}
const renderLabelWidth = type => {
  switch (type) {
    case 'form':
      return '88px'
    case 'editor':
      return '128px'
    case 'loginPhone':
      return '100px'
    case 'invoice':
      return '0px'
    default:
      return ''
  }
}

/**
 * 表單是否有變更
 */
const isDirty = computed(() =>
  props.needDiff ? !isEqual(newData, oldData) : true,
)

/**
 * 調用 `<el-form>` 的 validate 方法
 */
const validate = async () =>
  (await customFormRef.value.validate().catch(() => false)) && isDirty.value
const validateField = async key =>
  await customFormRef.value.validateField(key).catch(() => false)

const isValidRequired = computed(() => {
  let validStatus = true
  props.cols.forEach(col => {
    const { id, rules = [] } = col
    const isRequired = rules.filter(r => r.required).length > 0
    const value = newData[id]
    if (isRequired) {
      if (!value || value === '') {
        validStatus = false
      } else if (checkArr(newData[id])) {
        validStatus = newData[id].length > 0
      }
    }
  })
  return validStatus && isDirty.value
})
const isChanged = computed(() => {
  return !isEqual(newData, oldData)
})
const onInputMaskValue = (e, key) => {
  newData[key] = e.target.value
  // NOTE: 為了觸發驗證
  validate()
}

const exitFn = async () => {
  if (isChanged.value && props.leaveConfirm) {
    let isLeave = false
    await ElMessageBox.confirm(
      '您已經修改內容，請確定是否離開編輯視窗。',
      '確定離開編輯視窗？',
      {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning',
      },
    )
      .then(() => {
        isLeave = true
      })
      .catch(() => {
        isLeave = false
      })
    if (!isLeave) return false
    emit('exit')
  } else {
    emit('exit')
  }
}
onBeforeRouteLeave(async () => {
  if (isChanged.value && props.leaveConfirm) {
    let isLeave = false
    await ElMessageBox.confirm(
      '您已經修改內容，請確定是否離開編輯視窗。',
      '確定離開編輯視窗？',
      {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning',
      },
    )
      .then(() => {
        isLeave = true
      })
      .catch(() => {
        isLeave = false
      })
    if (!isLeave) return false
  }
})

defineExpose({
  validate,
  validateField,
  isValidRequired,
})
</script>

<style lang="scss">
.custom-form {
  // type === 'phone' 時，設定國碼選單樣式
  .country-codes-select.el-select {
    overflow: hidden;
    border-radius: 6px;

    .el-select__wrapper {
      height: 48px;
      box-shadow: none;
    }
  }

  .el-form-item__label:has(.country-codes-select) {
    padding: 0;
    height: 48px;
  }
}
</style>
